import { render, staticRenderFns } from "./CourseShow.vue?vue&type=template&id=4210e981&scoped=true&"
import script from "./CourseShow.vue?vue&type=script&lang=js&"
export * from "./CourseShow.vue?vue&type=script&lang=js&"
import style0 from "./CourseShow.vue?vue&type=style&index=0&id=4210e981&lang=scss&scoped=true&"
import style1 from "./CourseShow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210e981",
  null
  
)

export default component.exports